module.exports = __webpack_public_path__ + "img/Teutonia_Zirkel_transparent_black.5832691a.png";